import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import { NEWSBOARD_POST_FORM_FIELD_NAME_POST_AGE } from '../../NewsboardPostForm.constants'

import { getNextValue } from './PostAgeField.utils'

function PostAgeField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        info: t('Newsboard.PostAgeInfoKey'),
        label: `${t('Newsboard.PostAgeLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getNextValue}
      inline={isMobileScreenSize}
      name={NEWSBOARD_POST_FORM_FIELD_NAME_POST_AGE}
      placeholder={t('Newsboard.PostAgePlaceholderKey')}
    />
  )
}

export default PostAgeField
